module.exports = __webpack_public_path__ + "static/media/work2.81e4cd11.jpg";